var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"9"}},[_c('back-btn')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }